import { useAtomValue } from 'jotai';
import { useEffect, useMemo, useState } from 'react';

import { useSaveCompanyData, useSaveCompanyMap } from '../../../services/hooks/useSaveCompanyData';
import { TemporalPlainDateFromJsDate } from '../../../util/date-utilts';
import { QuartersBuilder } from '../services/QuartersBuilder';
import { metricsResponseByDateAtom } from '../state/MetricsStateJ';
import { selectedViewDatePFJ } from '../state/PageStateJ';
import { useSelectedCurrency } from '../../../hooks/useSelectedCurrency';

export function useInitializeMetricsData() {
  const date = useAtomValue(selectedViewDatePFJ);
  const { selectedCurrency } = useSelectedCurrency();
  const tDate = TemporalPlainDateFromJsDate(date);
  const metricsResponse = useAtomValue(
    metricsResponseByDateAtom({ date: tDate, currency: selectedCurrency })
  );
  const previousQuarterDate = useMemo(() => QuartersBuilder.getPreviousQuarterEnd(date), [date]);
  const tPreviousQuarterDate = TemporalPlainDateFromJsDate(previousQuarterDate);
  const previousMetricsResponse = useAtomValue(
    metricsResponseByDateAtom({ date: tPreviousQuarterDate, currency: selectedCurrency })
  );

  const { batchSaveCompanyData } = useSaveCompanyData(true);
  const saveCompanyMap = useSaveCompanyMap();

  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!metricsResponse.isSuccess || !previousMetricsResponse.isSuccess) {
      return;
    }
    batchSaveCompanyData(metricsResponse.data.included);
    saveCompanyMap(metricsResponse.data.included);
    setReady(true);
  }, [batchSaveCompanyData, metricsResponse, previousMetricsResponse, saveCompanyMap]);

  // Both responses for the current date, unlike `ready`, which stays true across date changes.
  const loaded = metricsResponse.isSuccess && previousMetricsResponse.isSuccess;

  return {
    previousQuarterDate,
    ready,
    loaded,
  };
}
